/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_FailedInputs */

const en_ticket_action_failed = /** @type {(inputs: Ticket_Action_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action failed`)
};

const ja_ticket_action_failed = /** @type {(inputs: Ticket_Action_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作に失敗しました`)
};

const fr_ticket_action_failed = /** @type {(inputs: Ticket_Action_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'action`)
};

const de_ticket_action_failed = /** @type {(inputs: Ticket_Action_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Action failed" |
*
* @param {Ticket_Action_FailedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_failed = /** @type {((inputs?: Ticket_Action_FailedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_FailedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_failed(inputs)
	if (locale === "ja") return ja_ticket_action_failed(inputs)
	if (locale === "fr") return fr_ticket_action_failed(inputs)
	return de_ticket_action_failed(inputs)
});